// extracted by mini-css-extract-plugin
export var downArrow = "_7z-0";
export var label = "_7z-1";
export var treatmentCard = "_7z-3";
export var upArrow = "_7z-2";